import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import keycloak from './auth/keycloak';
import { isEmbedded } from './auth/embeddedAuth';
import { initEmbeddedKeycloak } from './auth/embeddedKeycloak';

const root = ReactDOM.createRoot(document.getElementById('root'));

const renderApp = () =>
  root.render(
    <React.StrictMode>
      <ReactKeycloakProvider authClient={keycloak}>
        <App />
      </ReactKeycloakProvider>
    </React.StrictMode>
  );

if (isEmbedded()) {
  // Token comes from the host app via postMessage: no login redirect inside the iframe
  initEmbeddedKeycloak(keycloak)
    .then(renderApp)
    .catch((err) => {
      console.error(err);
      root.render(<p style={{ padding: 16 }}>Could not connect to the host application.</p>);
    });
} else {
  keycloak.init({ onLoad: 'login-required' }).then((authenticated) => {
    if (authenticated) {
      renderApp();
    } else {
      keycloak.login();
    }
  });
}

reportWebVitals();